var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
export var AppHostedRouteComponent = function (_a) {
    var officeHomeAppRouteConfig = _a.officeHomeAppRouteConfig, rootPath = _a.rootPath;
    var routeJsx = useMemo(function () { return (React.createElement(Switch, null,
        officeHomeAppRouteConfig.map(function (_a) {
            var route = _a.route;
            return (React.createElement(Route, __assign({ key: route.path ? route.path.toString() : '' }, route)));
        }),
        React.createElement(Route, { path: "*" },
            React.createElement(Redirect, { to: rootPath })))); }, [officeHomeAppRouteConfig, rootPath]);
    return routeJsx;
};
//# sourceMappingURL=AppHostedRouteComponent.js.map